export default {"src":"/_next/static/media/android.4188b39e.svg","height":49,"width":154,"blurWidth":0,"blurHeight":0};